import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';
import { UiDisclosurePanelComponent } from '@nexus/frontend-shared-ui';
import type { WishlistActivityFeedItemView } from '../../types/wishlist-activity-feed-item-view.interface';
import { WishlistActivityFeedComponent } from '../wishlist-activity-feed/wishlist-activity-feed.component';

@Component({
  selector: 'wishlist-detail-activity-panel',
  imports: [UiDisclosurePanelComponent, WishlistActivityFeedComponent],
  templateUrl: './wishlist-detail-activity-panel.component.html',
  styleUrl: './wishlist-detail-activity-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistDetailActivityPanelComponent {
  public readonly activities: InputSignal<readonly WishlistActivityFeedItemView[]> =
    input<readonly WishlistActivityFeedItemView[]>([]);
}
